import type { PageData } from '../../../../_metronic/helpers/utils/types';

export const businessData: PageData = [
  {
    formId: 'form1',
    heading: 'Business Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' }
    ]
  }
];
